import {BridgeComponent} from "@hotwired/hotwire-native-bridge"

export class BridgeMenuController extends BridgeComponent {
    static component = "menu"
    static values = {
        payload: Object
    }

    connect() {
        super.connect()
        if (this.bridgeElement.enabled) {
            this.send("connect", this.payloadValue)
        }
    }
}
